module.exports = __webpack_public_path__ + "static/media/corporate-services-img23.e8b9a751.jpg";